import WIDGETS from './widgets';

export default {
	name: 'kind_contacts',
	spacing: 2,
	widgets: [{ content: WIDGETS.CONTACTS_OVERVIEW, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 }],
};
